'use strict';

import template from './get_started.html';

export default {
  template: template,
  bindings: {},
  controllerAs: 'ctrl',
  controller: function (social, userModel, analyticsSa) {
    'ngInject';
    let self = this;
    this.url = `https://www.showaround.com/locals/${userModel.item.id}?reqRef=1`;

    // TODO: put this event tracking somewhere else, lots of possible duplicates
    const TRACK_GET_STARTED_AVAILABLE = 'event-getStartedAvailable';
    analyticsSa.track({action: TRACK_GET_STARTED_AVAILABLE, data: {}});

    this.copyUrlToClipboard = () => {
      var copyElement = document.createElement("textarea");
      copyElement.style.position = 'fixed';
      copyElement.style.opacity = '0';
      copyElement.textContent = self.url;
      var body = document.getElementsByTagName('body')[0];
      body.appendChild(copyElement);
      copyElement.select();
      document.execCommand('copy');
      body.removeChild(copyElement);
    }

    this.sendReference = () => {
      const TRACK_SEND_REFERENCE_CLICK = 'click-sendReferenceRequestFb';
      analyticsSa.track({action: TRACK_SEND_REFERENCE_CLICK, data: {}});
      return social.fetchScripts('fb').then(() => {
        social.getSocialNetwork('fb').sendRequest(this.url);
      });
    };

    this.browseLocals = () => {
      const TRACK_BROWSE_LOCALS_CLICK = 'click-browseLocalsGetStarted';
      analyticsSa.track({action: TRACK_BROWSE_LOCALS_CLICK, data: {}});
    };

    this.getUserLocation = () => {
      return {
        placeId: userModel.item.location.placeId,
        name: userModel.item.location.name,
      };
    };
  }
};



// WEBPACK FOOTER //
// ./app/src/modules/settings/get_started/get_started.js